import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 no-underline">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-circle-fill text-white text-xl w-5 h-5 flex items-center justify-center"></i>
              </div>
              <span className="text-lg font-heading font-bold text-background-50 whitespace-nowrap">
                精品视频精选
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              精品视频汇聚全网高清优质内容，涵盖影视、教育、娱乐、纪录片等多元类型。每一部精品视频均经严格筛选。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors">首页</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors">关于我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系方式</h4>
            <ul className="space-y-2.5 text-sm text-background-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line w-4 h-4 flex items-center justify-center"></i>
                contact@jingpinsp.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line w-4 h-4 flex items-center justify-center"></i>
                400-888-9999
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line w-4 h-4 flex items-center justify-center"></i>
                北京市朝阳区科技园区88号
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; {new Date().getFullYear()} 精品视频精选平台. 保留所有权利.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-500 hover:text-background-200 transition-colors text-sm">隐私政策</a>
            <a href="#" className="text-background-500 hover:text-background-200 transition-colors text-sm">服务条款</a>
            <a href="#" className="text-background-500 hover:text-background-200 transition-colors text-sm">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}